module.exports = __webpack_public_path__ + "img/click_tab5_mobile.d9e39fbd.png";